import { Component, EventEmitter, Output } from '@angular/core';
import {
  SELLER_TOOLBAR_FAB,
  SELLER_TOOLBAR_ITEMS,
} from '../dashboard-toolbar/dashboard-toolbar.configs';

/**
 * Seller preset of the data-driven dashboard toolbar.
 *
 * Keeps the seller bottom-navigation config in a single place and forwards the
 * central FAB tap. Pages just drop <app-seller-dashboard-toolbar />.
 */
@Component({
  selector: 'app-seller-dashboard-toolbar',
  template: `<app-dashboard-toolbar
    [items]="items"
    [fab]="fab"
    (fabClick)="fabClick.emit()"
  ></app-dashboard-toolbar>`,
  standalone: false
})
export class SellerDashboardToolbarComponent {
  readonly items = SELLER_TOOLBAR_ITEMS;
  readonly fab = SELLER_TOOLBAR_FAB;

  @Output() fabClick = new EventEmitter<void>();
}
